import api from '../token';

export const UltimosPedidos = async () => {
  try {
    const response = await api.post('/ultimosPedido');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar produtos:', error);
    return [];
  }
};

